export const en = {
  label: 'Project Key: ',
  copied: 'Copied to clipboard!',
  copy: 'Copy',
  articleId: '33902',
  inputId: 'apiInput'
};

export type Translations = typeof en;
